import type { LimitOrderCancelResponse } from 'apiConnector/secondary-market/limit-order/models';
import { secondaryMarketCancellationActionsFactory } from 'state/secondaryMarket/shared/cancellation/cancellation.actions';

export const limitOrderCancellationActions = secondaryMarketCancellationActionsFactory<
  LimitOrderCancelResponse,
  'LIMIT_ORDER'
>('LIMIT_ORDER');
type TypeofLimitOrderCancellationActions = typeof limitOrderCancellationActions;
export type SecondaryMarketLimitOrderCancellationWorkflowInit = ReturnType<
  TypeofLimitOrderCancellationActions['secondaryMarketCancellationWorkflowInit']
>;
export type SecondaryMarketLimitOrderCancellationWorkflowAborted = ReturnType<
  TypeofLimitOrderCancellationActions['secondaryMarketCancellationWorkflowAborted']
>;
export type SecondaryMarketLimitOrderCancellationWorkflowCompleted = ReturnType<
  TypeofLimitOrderCancellationActions['secondaryMarketCancellationWorkflowCompleted']
>;
export type SecondaryMarketLimitOrderCancellationRequested = ReturnType<
  TypeofLimitOrderCancellationActions['secondaryMarketCancellationRequested']
>;
export type SecondaryMarketLimitOrderCancellationReceived = ReturnType<
  TypeofLimitOrderCancellationActions['secondaryMarketCancelReceived']
>;
export type SecondaryMarketLimitOrderCancellationRejected = ReturnType<
  TypeofLimitOrderCancellationActions['secondaryMarketCancellationRejected']
>;
export type SecondaryMarketLimitOrderCancellationFailed = ReturnType<
  TypeofLimitOrderCancellationActions['secondaryMarketCancellationFailed']
>;
export type SecondaryMarketLimitOrderCancellationsActions = ReturnType<
  TypeofLimitOrderCancellationActions[keyof TypeofLimitOrderCancellationActions]
>;

export type LimitOrderCancellationActions = typeof limitOrderCancellationActions;
